<template>
<div>
<mu-appbar title="Mes paramètres" class="syn-navbar">
    <mu-flat-button :href="'#' + routeBack" class="syn-nav-button" slot="left" icon="arrow_back"></mu-flat-button>
</mu-appbar>
<div class="syn-content">
    <mu-row gutter>
    <mu-col width="100" tablet="60" desktop="60">
        <mu-paper :zDepth="1" rounded >
            <div class="card-toolbar color-black" style="background-color: #eeeeee; border: 1px solid #edf1f2;">
            <span class="card-toolbar-title" style="color: rgba(0, 0, 0, 0.87);">
                <a href="#/vouch" style="color:black;">Affichage</a>
            </span>
            <span><mu-icon value="cached"></mu-icon></span>
            </div>
            <div class="card-content">
            <mu-row gutter>
                <mu-col width="100" tablet="50" desktop="50">
                    <mu-time-picker label="Début Matin" labelFloat format="24hr"
                        v-model="pref.morning" lazy
                        okLabel="Ok" cancelLabel="Annuler" autoOk ></mu-time-picker>
                </mu-col>
                <mu-col width="100" tablet="50" desktop="50">
                    <mu-time-picker label="Début après-midi" labelFloat format="24hr"
                        v-model="pref.afternoon" lazy
                        okLabel="Ok" cancelLabel="Annuler" autoOk ></mu-time-picker>
                </mu-col>
                <!-- -->
                <mu-col width="100" tablet="50" desktop="50">
                    <mu-select-field v-model="pref.sticker" label="Impression étiquette">
                        <mu-menu-item value="1" title="Oui"></mu-menu-item>
                        <mu-menu-item value="0" title="Non"></mu-menu-item>
                    </mu-select-field>
                </mu-col>
                <mu-col width="100" tablet="50" desktop="50">
                    <mu-select-field v-model="pref.vouchLine" label="Nb lignes tableau">
                        <mu-menu-item :value="10" title="10"></mu-menu-item>
                        <mu-menu-item :value="12" title="12"></mu-menu-item>
                        <mu-menu-item :value="14" title="14"></mu-menu-item>
                        <mu-menu-item :value="15" title="15"></mu-menu-item>
                        <mu-menu-item :value="20" title="20"></mu-menu-item>
                        <mu-menu-item :value="30" title="30"></mu-menu-item>
                        <mu-menu-item :value="40" title="40"></mu-menu-item>
                    </mu-select-field>
                </mu-col>
                <mu-col width="100" tablet="50" desktop="50">
                    <mu-select-field v-model="pref.printList" label="Imprimer listing">
                        <mu-menu-item :value="0" title="0 page"></mu-menu-item>
                        <mu-menu-item :value="1" title="1 page"></mu-menu-item>
                        <mu-menu-item :value="2" title="2 pages"></mu-menu-item>
                    </mu-select-field>
                </mu-col>
                <mu-col width="100" tablet="50" desktop="50">
                    <mu-select-field v-model="pref.editStart" label="Démarrer edition sur">
                        <mu-menu-item :value="0" title="Expéditeur"></mu-menu-item>
                        <mu-menu-item :value="1" title="Destinataire"></mu-menu-item>
                        <mu-menu-item :value="2" title="Détails"></mu-menu-item>
                    </mu-select-field>
                </mu-col>
                <!-- Boutton -->
                <div style="text-align: right; padding-top:5px; width: 100%;">
                    <mu-raised-button @click="savePref()" label="Enregistrer" primary ></mu-raised-button>
                </div>
            </mu-row>
            </div>
        </mu-paper>
    </mu-col>
</mu-row>
</div>

</div>
</template>

<script>
import paper      from 'muse-components/paper'
import icon       from 'muse-components/icon'
import iconButton from 'muse-components/iconButton'
import appBar     from 'muse-components/appBar'
import flatButton from 'muse-components/flatButton'
import textField  from 'muse-components/textField'
import raisedButton from 'muse-components/raisedButton'
import selectField  from 'muse-components/selectField'
import timePicker   from 'muse-components/timePicker'
import {menu, menuItem} from 'muse-components/menu'
//import checkbox     from 'muse-components/checkbox'
import {col, row} from 'muse-components/grid'

export default {
    name: 'userpref',
    props: ['toast', 'option'],
    data: function () {
        return {
            routeBack : this.$auth.routeBefore,
            selectable:false,
            showCheckbox:false,
            pref: this.$auth.userPref
        }
    },
    methods: {
        savePref(){
            ns.localStorage.set( APP_COD + "_pref", this.pref )
            this.$router.push({ path: this.routeBack })
            this.toast('Préférences enregistrées !')
        }
    },
    mounted: function (){
        if( this.$auth.routeBefore === undefined ){
            this.routeBack = '/dashboard'
        }
    },
    components: {
        'mu-paper': paper,
        'mu-icon': icon,
        'mu-icon-button': iconButton,
        'mu-appbar': appBar,
        'mu-text-field': textField,
        'mu-flat-button': flatButton,
        'mu-raised-button': raisedButton,
        'mu-row': row, 'mu-col': col,
        'mu-select-field': selectField,
        'mu-time-picker': timePicker,
        'mu-menu': menu, 'mu-menu-item': menuItem
    }
}
</script>

<style lang="less">

</style>


// WEBPACK FOOTER //
// User_prefs.vue?9f2e88dc